import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight } from "lucide-react";
import { trackEvent } from "@/lib/trackEvent";

interface Props {
  coin?: string | null;
  articleId?: string;
  slug?: string;
}

export default function ArticleCtaBar({ coin, articleId, slug }: Props) {
  const href = coin ? `/coin-reviewer?coin=${encodeURIComponent(coin)}` : "/coin-reviewer";

  return (
    <div className="my-8 rounded-2xl border border-primary/30 bg-gradient-to-r from-primary/15 via-primary/5 to-transparent p-5 sm:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:justify-between">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
            <Sparkles className="w-5 h-5 text-primary" />
          </div>
          <p className="text-base sm:text-lg font-semibold leading-snug">
            Want a personalized review of the coins mentioned?
          </p>
        </div>
        <Button
          asChild
          size="lg"
          className="w-full sm:w-auto flex-shrink-0"
          onClick={() =>
            trackEvent("cta_clicked_to_coin_reviewer", {
              placement: "top_bar",
              coin: coin ?? null,
              article_id: articleId,
              slug,
            })
          }
        >
          <Link to={href}>
            Open Coin Reviewer
            <ArrowRight className="w-4 h-4 ml-2" />
          </Link>
        </Button>
      </div>
    </div>
  );
}
